import { Pane } from "evergreen-ui";
import { ContentPosition, DetailsPageSection } from "../../common/DetailsPageSection";
import { FooterActionBar } from "../../common/FooterActionBar";
import { useThemeImporter } from "./hooks/useThemeImporter";
import { ImportThemesFormFields } from "./ImportThemesFormFields";
import { useStoreEditDetailsContext } from "./StoreEditDetailsContext";

export const StoreEditThemesTab = (): JSX.Element => {
    const { store } = useStoreEditDetailsContext();
    const {
        formValues,
        setField,
        formStatusMessage,
        isFormValid,
        isFormDirty,
        resetForm,
        storefrontsData,
        storefrontsLoading,
        storefrontsError,
        submitImportThemes,
        importThemesLoading,
        importThemesCalled,
    } = useThemeImporter(store!); // store is guaranteed to be non-null here

    const hasStateChanges =
        isFormDirty && (formValues.existingStorefrontId !== "" || formValues.themes !== "");

    return (
        <Pane>
            <DetailsPageSection
                hideBorder={true}
                heading={
                    <div className="jc-header-wrapper">
                        <h3 className="jc-header-title">Import Existing Themes</h3>
                    </div>
                }
                contentPosition={ContentPosition.left}
            >
                <ImportThemesFormFields
                    existingStorefrontId={formValues.existingStorefrontId}
                    themes={formValues.themes}
                    storefrontsData={storefrontsData}
                    storefrontsLoading={storefrontsLoading}
                    storefrontsError={storefrontsError}
                    updateExistingStorefrontId={(value: string) =>
                        setField("existingStorefrontId", value)
                    }
                    updateThemes={(value: string) => setField("themes", value)}
                />
            </DetailsPageSection>
            {hasStateChanges && (
                <FooterActionBar
                    primaryButtonText={"Import"}
                    isPrimaryLoading={importThemesCalled && importThemesLoading}
                    primaryButtonDisabled={
                        !isFormValid || (importThemesCalled && importThemesLoading)
                    }
                    onPrimaryClick={submitImportThemes}
                    showSecondaryButton={false}
                    tertiaryButtonText={"Cancel"}
                    onTertiaryClick={resetForm}
                    infoComponent={<p>{formStatusMessage}</p>}
                />
            )}
        </Pane>
    );
};
